<template>
  <div id="app">
    <!-- NAVBAR -->
    <nav class="navbar navbar-fixed-top navbar-home">
        <div class="container">
            <router-link class="navbar-brand" to="/"><img height="76" src="./assets/logo.png" class="img-fluid" /></router-link>
            <button class="navbar-toggler hidden-sm-up" type="button" data-toggle="collapse" data-target="#exCollapsingNavbar2" aria-controls="exCollapsingNavbar2" aria-expanded="false" aria-label="Toggle navigation">
            &#9776;
            </button>
            <div class="collapse navbar-toggleable-xs clearfix" id="exCollapsingNavbar2">
                <div class="float-md-right float-xs-left">
                    <ul class="nav navbar-nav ">
                    <li class="nav-item">
                        <router-link class="nav-link" to="/registro">REGISTRO</router-link>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="#">ACCEDER</a>  
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="#blog">BLOG</a>
                        <!--<router-link class="nav-link" to="/">BLOG</router-link>-->
                    </li>
                </ul>
                </div>
                
            </div>
        </div>
    </nav>
    <div class="wpo-view">
        <router-view></router-view>
    </div>
    

    <div class="col-md-8 offset-md-2" style="text-align:center;">
      <div class="redesSociales">
        <a href="www.facebook.com" target="_blank"><img src="/static/home/icFb.png" alt="Facebook"></a>
        <a href="www.twitter.com" target="_blank"><img src="/static/home/icTw.png" alt="Twitter"></a>
      </div>
      <p class="copyright">Copyright <b>©</b> 2016 WPO.</p>
    </div>

  </div>
</template>

<script>

import Home from './components/Home'

export default {
  name: 'app',
  component: {
    Home,
  },
  head: {
    meta: [
      { name: 'description', content: 'World Part Online, la plataforma digital exclusiva para la comercialización de repuestos y accesorios de todos las marcas, de todas las industrias', id: 'desc' }
    ],
    link: [
      { rel: 'shortcut icon', href: '/static/favicon.ico', type: 'image/x-icon' }, 
    ],
  }
}
</script>

<style>
    body {
        background: #FFFFFF;
        font-family: 'Raleway', sans-serif;
        color: #333333;
        padding-bottom: 100px;
    }

    #app {
        font-family: 'Raleway', sans-serif;
    }

    .wpo-view {
        margin-top: 100px;
    }

    h1 {
        color: #29abe2;
    }

    /* NAVBAR */
    .navbar-home {
        background-color: #EAEAEA;
    }

    .navbar-home .navbar-toggleable-xs {
        padding-top: 25px;
    }

    .navbar-home .nav-item {
        
        margin-right: 10px;
        font-weight: bold;
    }

    .navbar-home .nav-link {
        color: #000;
    }
    /* NAVBAR */

    /* CAROUSEL */
    .carousel-inner img {
        
        margin: 0 auto;
    }

    .carousel-caption {
        bottom: 0;
        top: 20%;
    }

    .carousel-caption h3{
        font-weight:100;
        font-size: 40px;
        margin-bottom: 30px;
    }

    .carousel-caption p{
        font-weight:100;
        font-size: 25px;
    }
    /* CAROUSEL */

    .header {
        text-align: center;
        margin-top: 40px;
        margin-bottom: 40px;
        position: relative;
    }

    .header h2 {
        display: table;
        white-space: nowrap;
        color: #428BCA;
        font-size: 30px;
    }
    .header h2:before, .header h2:after {
        border-top: 2px solid #428BCA;
        content: '';
        display: table-cell;
        position: relative;
        top: 0.5em;
        width: 45%;
    }
    .header h2:before { right: 1.5%; }
    .header h2:after { left: 1.5%; }

    #suscripcion {
        margin-top: 40px;
        background: #2AABE4;
        height: 90px;
        padding-top: 25px;
        color: #fff;
    }

    #suscripcion h2{
        padding-left: 30px;
        font-size: 30px;
    }

    #suscripcion input{
        border: 2px solid #ccc;    
    }

    #suscripcion button{
        background: #196C7E;    
    }

    

    /*SERVICIOS*/
    #servicios .card {
        border: 0;
    }

    #servicios p {
        font-size: 12px;
    }
    /*SERVICIOS*/

    /*REDES SOCIALES*/
    .redesSociales {
        margin-top: 50px;
        margin-bottom: 30px;
    }
    /*REDES SOCIALES*/
</style>


// WEBPACK FOOTER //
// App.vue?6f31c953